module.exports = __webpack_public_path__ + "static/media/gameboy.c37bcdcc.png";